/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyLegalRepresentative = {
  properties: {
    cpf: {
      type: 'string',
    },
    name: {
      type: 'string',
    },
    qualification: {
      type: 'string',
    },
  },
} as const;
